import React, { useCallback, useEffect, useMemo } from "react";
import { useForm, useFormState } from "react-final-form";
import { useSelector } from "react-redux";
import Input from "rs-components/Input";
import SelectInput from "rs-components/Input/components/SelectInput";
import SelectItemRenderer from "rs-components/Input/components/SelectInput/components/SelectItemRenderer";
import { FormField } from "../../../../index";
import { ResultElementParameterType, } from "store/rs-workspace/rs-workspace.types";
import { getInsightOutputOptionsSelector, OUTPUT_FINAL_ID, } from "store/rs-workspace/selectors/rs-workspace.selectors";
import * as styles from "../../../../styles.module.scss";
const InsightOutputSelect = ({ restrictions, selectedParameters }) => {
    const form = useForm();
    const formState = useFormState();
    const { insightId, inputSetId, output } = useMemo(() => ({ ...formState.values }), [formState.values]);
    const insightOutputOptions = useSelector(getInsightOutputOptionsSelector(insightId, inputSetId, output?.id ?? undefined));
    const options = useMemo(() => insightOutputOptions.filter((item) => {
        const columnWithCurrentParams = selectedParameters.find((parameter) => {
            if (parameter.type === ResultElementParameterType.INSIGHT) {
                return (insightId === parameter.insightId &&
                    inputSetId === parameter.inputSetId &&
                    (parameter.output.id === item.value ||
                        (parameter.output.isFinal && item.value === OUTPUT_FINAL_ID)));
            }
            return false;
        });
        return !columnWithCurrentParams;
    }), [selectedParameters, inputSetId, insightId, insightOutputOptions]);
    const selectedValue = useMemo(() => options.find(({ value }) => value === output?.id), [output?.id, options]);
    const handleChange = useCallback((outputId) => {
        form.change(FormField.OUTPUT, { id: outputId, isFinal: outputId === OUTPUT_FINAL_ID });
    }, [form]);
    useEffect(() => {
        if (!output?.id && options[0]) {
            form.change(FormField.OUTPUT, { id: options[0].value, isFinal: options[0].value === OUTPUT_FINAL_ID });
            form.blur(FormField.OUTPUT);
        }
        else if (output?.id && !options.find(({ value }) => value === output?.id)) {
            form.change(FormField.OUTPUT, {
                id: options[0]?.value,
                isFinal: options[0]?.value === OUTPUT_FINAL_ID,
            });
            form.blur(FormField.OUTPUT);
        }
    }, [form, options, output?.id]);
    return (React.createElement("div", { className: styles.field },
        React.createElement(Input, { component: SelectInput, name: FormField.OUTPUT, label: "Insight output", items: options, value: selectedValue, disableFormChange: true, onChange: ({ value }) => handleChange(value), itemRenderer: SelectItemRenderer, classes: { component: styles.selectWrapper, label: styles["field-label"] }, restrictions: restrictions })));
};
export default InsightOutputSelect;
